import React, { useMemo } from 'react';
import { Alert, Box } from '@mui/material';
import type { LegacyAuditsSectionProps } from './types';
import LegacyAuditTable from './LegacyAuditTable';

const LegacyAuditsSection: React.FC<LegacyAuditsSectionProps> = ({
  store,
  auditReports,
  auditReportsLoading,
  auditReportsError,
  onRefresh,
  dateRangeLabel,
  auditDateRange,
  setAuditDateRange,
}) => {
  const rows = useMemo(() => auditReports?.daily_summaries ?? [], [auditReports]);

  return (
    <Box >
      {auditReportsError && (
        <Alert severity="error" sx={{ mt: 3 }}>
          {auditReportsError}
        </Alert>
      )}

      <LegacyAuditTable rows={rows} store={store} loading={auditReportsLoading} />
    </Box>
  );
};

export default LegacyAuditsSection;
